import { TextField, TextFieldProps } from '@mui/material'
import { useState } from 'react'
import DialogBase, { DialogBaseProps } from './DialogBase'

export type InputDialogBaseProps = DialogBaseProps & {
  dflt_value?: string;
  textFieldProps?: TextFieldProps;
}

const InputDialogBase = ({ dflt_value, textFieldProps, ...props }: InputDialogBaseProps) => {

  const [text, setText] = useState((dflt_value == null ? "" : dflt_value));

  return (
    <DialogBase

      dialogContentProps={{ sx: { paddingTop: 0 } }}
      content={
        <div>
          <TextField fullWidth value={text} onChange={(event) => {
            setText(event.target.value)
          }} {...textFieldProps} />
        </div>
      }

      {...props}

      onDialogResult={(e) => {// 注意! 要放在 ...props 後面覆寫事件
        e.Data = text;
        props.onDialogResult?.(e);
      }}

    />
  )
}

export default InputDialogBase